// extracted by mini-css-extract-plugin
export default {"modal":"HardwareFirstSizingModal_modal__vGMdQ","breedListOpen":"HardwareFirstSizingModal_breedListOpen__yj5Mh","closeIcon":"HardwareFirstSizingModal_closeIcon__Svppt"};